const AUTH_TOKEN = 'AUTH_TOKEN';
const REFRESH_TOKEN = 'REFRESH_TOKEN';
const REFERENCE_NUMBER = 'REFERENCE_NUMBER';
const ROLE_PERMISSION = 'ROLE_PERMISSION';
const URL_HISTORY = 'URL_HISTORY';
const setAccessToken = (token) => {
    localStorage.setItem(AUTH_TOKEN, token);
};
const setRefreshToken = (token) => {
    localStorage.setItem(REFRESH_TOKEN, token);
};
const setReferenceNumber = (refNumber) => {
    localStorage.setItem(REFERENCE_NUMBER, refNumber);
};
const getAccessToken = () => {
    return localStorage.getItem(AUTH_TOKEN);
};
const getRefreshToken = () => {
    return localStorage.getItem(REFRESH_TOKEN);
};
const getReferenceNumber = () => {
    return localStorage.getItem(REFERENCE_NUMBER);
};
const removeAccessToken = () => {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem(ROLE_PERMISSION);
};
const removeRefreshToken = () => {
    localStorage.removeItem(REFRESH_TOKEN);
};
const removeReferenceNumber = () => {
    localStorage.removeItem(REFERENCE_NUMBER);
};
const setRolePermission = (rolePermission) => {
    localStorage.setItem(ROLE_PERMISSION, JSON.stringify(rolePermission));
};
const getRolePermission = () => {
    const rolePermissionString = localStorage.getItem(ROLE_PERMISSION);
    if (rolePermissionString) {
        return JSON.parse(rolePermissionString);
    }
    return null;
};
const getURLHistory = () => {
    return JSON.parse(localStorage.getItem(URL_HISTORY) || '[]');
};
const setURLHistory = (url, recordNumber) => {
    const currentHistory = getURLHistory();
    const lastItem = currentHistory[currentHistory.length - 1];
    const lastKey = lastItem ? `${lastItem.url}::${lastItem.recordNumber}` : null;
    const newKey = `${url}::${recordNumber}`;
    if (newKey === lastKey) {
        return;
    }
    const newItem = {
        Id: currentHistory.length > 0 ? currentHistory[currentHistory.length - 1].Id + 1 : 1,
        url,
        recordNumber,
        priority: 0
    };
    currentHistory.push(newItem);
    localStorage.setItem(URL_HISTORY, JSON.stringify(currentHistory));
};
const removeURLHistory = () => {
    localStorage.removeItem(URL_HISTORY);
};
const updateURLHistory = (id) => {
    const currentHistory = getURLHistory();
    const index = currentHistory.findIndex((item) => item.Id === id);
    if (index !== -1) {
        if (currentHistory[index].priority > 0) {
            currentHistory[index].priority = 0;
        }
        else {
            const maxPriority = currentHistory.reduce((max, item) => (item.priority > max ? item.priority : max), 0);
            currentHistory[index].priority = maxPriority + 1;
        }
        localStorage.setItem(URL_HISTORY, JSON.stringify(currentHistory));
    }
};
const LocalStorageService = {
    setAccessToken,
    setRefreshToken,
    setReferenceNumber,
    getAccessToken,
    getRefreshToken,
    getReferenceNumber,
    removeAccessToken,
    removeRefreshToken,
    removeReferenceNumber,
    setRolePermission,
    getRolePermission,
    setURLHistory,
    getURLHistory,
    removeURLHistory,
    updateURLHistory
};
export default LocalStorageService;
